import User from "./User" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  UserRemaindersRequest extends  DBObject {  private static readonly _ASCENDING: number = 0 ;
  private static readonly _ORDERBY: number = 1 ;
  private static readonly _USER: number = 2 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _user: User = null ;
  private _orderBy: string = '' ;
  private _ascending: boolean = false ;
 public constructor ( d3eParams ? : Partial<{ascending: boolean, orderBy: string, user: User}> ) {
 super();

this.setAscending(d3eParams?.ascending ?? false);

this.setOrderBy(d3eParams?.orderBy ?? '');

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'UserRemaindersRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(UserRemaindersRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get orderBy (  ) : string {
 return this._orderBy ; 
 }
  public setOrderBy ( val : string ) : void {
 let isValChanged :boolean=this._orderBy !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(UserRemaindersRequest._ORDERBY,this._orderBy);

this._orderBy=val;

this.fire('orderBy',this);
 }
  public get ascending (  ) : boolean {
 return this._ascending ; 
 }
  public setAscending ( val : boolean ) : void {
 let isValChanged :boolean=this._ascending !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(UserRemaindersRequest._ASCENDING,this._ascending);

this._ascending=val;

this.fire('ascending',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case UserRemaindersRequest._USER : {
 return this._user ; 
 }

case UserRemaindersRequest._ORDERBY : {
 return this._orderBy ; 
 }

case UserRemaindersRequest._ASCENDING : {
 return this._ascending ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : UserRemaindersRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :UserRemaindersRequest=( dbObj as UserRemaindersRequest );

obj.id=this.id;

obj.setUser(this._user);

obj.setOrderBy(this._orderBy);

obj.setAscending(this._ascending);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case UserRemaindersRequest._USER : {
 this.setUser(( value as User ));
 break; }

case UserRemaindersRequest._ORDERBY : {
 this.setOrderBy(( value as string ));
 break; }

case UserRemaindersRequest._ASCENDING : {
 this.setAscending(( value as boolean ));
 break; }
 }
 }
 }